export const trackSwipeDown = (swipeInitialPosition, onDone) => {
  const move = (event) => {
    const closeThreshold = 100;

    if (event.touches[0].clientY - swipeInitialPosition >= closeThreshold) {
      // eslint-disable-next-line
      cleanup();
      onDone();
    }
  };

  const cleanup = () => {
    window.removeEventListener('touchmove', move);
    window.removeEventListener('touchend', cleanup);
  };

  window.addEventListener('touchmove', move, false);
  window.addEventListener('touchend', cleanup, false);

  return cleanup;
};
